import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import "./style.css";

function slideUp(element, duration = 300) {
    element.style.height = element.scrollHeight + 'px';
    element.offsetHeight; // Force reflow
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0';
    element.style.overflow = 'hidden';

    setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
    }, duration);
}

function slideDown(element, duration = 300) {
    element.style.removeProperty('display');
    let height = element.scrollHeight;
    element.style.height = '0';
    element.style.overflow = 'hidden';
    element.offsetHeight; // Force reflow
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
    }, duration);
}

function slideToggle(element, duration = 300) {
    const isHidden = window.getComputedStyle(element).display === 'none';
    isHidden ? slideDown(element, duration) : slideUp(element, duration);
}


/**
 * @name PromoBanner
 * @function
 * @returns {JSX}
 * @description Displays the Promotional Banner
 */
const PromoBanner = () => {

    const panelRef = useRef(null);
    const [isOpen, setIsOpen] = useState(true);
    const { title, imageUrl, body: htmlContent, displayEnabled } = useSelector((state) => state.promoBanner);

    // check for enable banner
    if (displayEnabled !== '1') {
        return null;
    }

    const toggle = () => {
        const panel = panelRef.current;
        if (!panel) return;

        if (isOpen) {
            slideUp(panel, 300);
        } else {
            slideDown(panel, 300);
        }

        setIsOpen(!isOpen);
    };

    return (
        <section className="promoBanner">
            <div ref={panelRef} >
                <div className="promoBanner__container">
                    <div className="promoBanner__container__image">
                        <img src={imageUrl} width="204" height="135" />
                    </div>
                    <div className="promoBanner__container__content" dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                </div>
            </div>
            <div className="promoBanner__cta">
                <button className="promoBanner__cta__btn" aria-expanded={isOpen ? 'true' : 'false'} onClick={() => toggle()}>
                    {title}
                </button>
            </div>
        </section>
    )
}

export default PromoBanner;